import style from './index.module.scss';
import classnames from 'classnames/bind';
const className = classnames.bind(style);

interface PropsTarget {
    title:string,
    values:string
}

const TxtValues = (props: PropsTarget)=>{
    const {title,values} = props;
    return(
        <div className={className('spantxt')}>
          <div className={className('title')}>
            {title}
          </div>
          { values &&
            <div className={className('values')}>
              {values}
            </div>
          }
        </div>
    )
}

export default TxtValues;